module.exports = __webpack_public_path__ + "img/Micronesia.161e1746.svg";